import { Box, InlineStack, PlainButton, Tooltip } from '@customerio/pluma-components/react';
import React from 'react';
import { mergeRefs } from 'react-merge-refs';
import * as styles from './index.css';
import { isEmptyString } from '@/utils/string';

export interface MessageContainerProps extends React.ComponentProps<typeof Box> {
  variant: 'user' | 'model';
}

export function MessageContainer({ variant, children, ...props }: MessageContainerProps) {
  return (
    <Box {...props} className={styles.messageContainerVariants[variant]}>
      <Box className={[styles.messageContainerContent, styles.messageContainerContentVariants[variant]]}>
        {children}
      </Box>
    </Box>
  );
}

export function MessageActionsContainer({
  isVisible = false,
  children,
  ...props
}: {
  isVisible?: boolean;
  children: React.ReactNode;
} & React.ComponentProps<typeof InlineStack>) {
  return (
    <InlineStack
      gap="050"
      {...props}
      className={[styles.messageActionsContainer, isVisible && styles.visibleMessageActionsContainer]}
    >
      {children}
    </InlineStack>
  );
}

interface MessageActionProps extends React.ComponentProps<typeof PlainButton> {
  variant?: 'default' | 'active';
  tooltip?: string;
  children: React.ReactNode;
}

export function MessageAction({
  variant = 'default',
  tooltip,
  className = '',
  children,
  ref: forwardedRef,
  ...props
}: MessageActionProps & { ref?: React.Ref<HTMLButtonElement> }) {
  return (
    <Tooltip content={tooltip} placement="top" isCustom={true} isDisabled={isEmptyString(tooltip)}>
      {(context) => (
        <PlainButton
          className={[styles.messageAction, styles.messageActionVariants[variant], className]}
          ref={mergeRefs([forwardedRef, context.reference.setReference])}
          {...context.reference.getReferenceProps(
            // oxlint-disable-next-line typescript/consistent-type-assertions, typescript/no-explicit-any -- pre-existing assertion and explicit any; replace with precise types when touched
            props as any,
          )}
        >
          {children}
        </PlainButton>
      )}
    </Tooltip>
  );
}
